export const navListInjection = Symbol();
export const formInputInjection = Symbol();
export const tabInjection = Symbol();
export const expansionPanelInjection = Symbol();
export const sliderItemInjection = Symbol();
export const mapInjection = Symbol();
